/**
 * `environmentConfiguration` field keys `GET /api/enterprise/get-public-info` ever returns,
 * mirroring the `PRE_LOGIN_ENV_FIELDS` allowlist in the backend's `routes/enterprise.js`
 * (the actual enforcement point). That endpoint is unconditional - it returns exactly this
 * set regardless of auth state. Post-login config comes from the authenticated
 * `GET /api/config` instead (see `SettingsService.extractEnvironmentConfig()`).
 */

export const PRE_LOGIN_ENV_FIELDS = [
	'authTokenKey', 'refreshTokenKey',
	'recaptcha', 'siteKey', 'commercialized', 'auth2fa', 'hidePasswordLogin',
	'enableOAuthSSO', 'enableSAMLSSO', 'SSO_SIGNIN_BUTTON_TEXT', 'redirectURISSO', 'ssoClientId',
	'DIRECT_REDIRECT_SAML', 'DIRECT_SAML_URL', 'requireSigning', 'BRAND_FONT_FAMILY',
	// Read by the root shell (app.component.ts, font stylesheet choice) and by the login
	// page's own wrapper (auth.component.ts, UptimeAI branding) - both run pre-login.
	'onPremDeployment', 'CUSTOM_SAAS_DEPLOYMENT'
];
